import {
  chakra,
  ModalCloseButton as CkModalCloseButton,
  ModalContent as CkModalContent,
  Button as CkButton
} from '@chakra-ui/react'
import { EZIndexLayer } from 'enums/theme'

export const CircleCloseButton = chakra(CkModalCloseButton, {
  baseStyle: () => ({
    display: { base: 'none', lg: 'block' },
    borderRadius: '9999px',
    boxShadow: 'base',
    marginTop: 10,
    marginRight: 10,
    translateY: '50%',
    background: 'white !important',
    zIndex: EZIndexLayer.UPPER
  })
})

export const ModalContent = chakra(CkModalContent, {
  baseStyle: () => ({
    position: 'relative',
    borderRadius: '0px'
  })
})

export const BottomButton = chakra(CkButton, {
  baseStyle: () => ({
    paddingX: { base: 6, lg: 4 },
    height: { base: '48px', lg: '40px' }
  })
})

export const BottomBackButton = chakra(CkButton, {
  baseStyle: () => ({
    paddingX: { base: 6, lg: 4 },
    border: '1px solid #E2E8F0',
    height: { base: '48px', lg: '40px' },
    background: 'white'
  })
})
